import {createSelector} from 'reselect';
import dayjs from 'utils/dayjs-timezone';

const getParkingPassSlice = state => state.parkingPass;

export const getParkingPass = createSelector(
    [getParkingPassSlice],
    parkingPassSlice => {
        return {
            ...parkingPassSlice,
            data:
                parkingPassSlice.data &&
                Object.keys(parkingPassSlice.data).length > 0
                    ? {
                          ...parkingPassSlice.data,
                          starts: dayjs
                              .utc(parkingPassSlice.data.starts)
                              .tz(parkingPassSlice.data.timezone),
                          ends: dayjs
                              .utc(parkingPassSlice.data.ends)
                              .tz(parkingPassSlice.data.timezone),
                      }
                    : {},
        };
    }
);
